import styled from 'styled-components';
import { styleConfig } from 'config';


const MessagesListContainer = styled.ul`
  text-decoration: none;
  list-style: none;
  padding: 0;
  margin-bottom: 0;
`
export default MessagesListContainer;
